import { hover } from 'pobble-components/dist/jss-mixins'

const styles = ({ FONT_SIZES, COLORS, BREAKPOINTS }) => ({
  listItem: {
    textDecoration: 'none',
    padding: '0 0 0.5em',
    borderBottom: '0.25em solid transparent',
    '&:first-child': {
      marginLeft: '0'
    },
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      marginLeft: '0'
    },
    ...hover({
      '& $link': {
        color: COLORS.BLUE.NORMAL
      }
    })
  },
  active: {
    borderBottomColor: COLORS.BLUE.NORMAL,
    '& $link': {
      color: COLORS.BLUE.NORMAL
    }
  },
  link: {
    fontSize: '1em',
    lineHeight: '1.2',
    cursor: 'pointer',
    color: COLORS.TEXT.LIGHT_GREY.NORMAL
  }
})

export default styles
